import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { StripeVerificationSessionSummaryDto } from '@workspace/data-types';
import { CodeBlockComponent, LuxonDatePipe, SimpleChipComponent } from '@workspace/ng-aura';

@Component({
  selector: 'core-stripe-verification-session-details',
  templateUrl: './stripe-verification-session-details.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconModule,
    MatDividerModule,
    LuxonDatePipe,
    SimpleChipComponent,
    CodeBlockComponent,
    RouterModule,
  ],
})
export class StripeVerificationSessionDetailsCoreComponent {
  session = input.required<StripeVerificationSessionSummaryDto>();

  readonly populatedUser = computed(() => {
    const sess = this.session();
    if (!sess || !sess.userId || typeof sess.userId === 'string') {
      return null;
    }
    return sess.userId as unknown;
  });
}
